export default __webpack_public_path__ + "static/media/Discussion_Forum_Wordmark.d166eb37.png";